import { api, setToken } from "./api";

export async function login(email, password) {
  const res = await api.post("/auth/login", { email, password });
  setToken(res.data.token);
  localStorage.setItem("role", res.data.role || "admin");
  localStorage.setItem("email", res.data.email || email);
  return res.data;
}

export function logout() {
  setToken(null);
  localStorage.removeItem("role");
  localStorage.removeItem("email");
}

export function isAuthed() {
  return !!localStorage.getItem("token");
}
